import { GraphSchema } from '@ta/server';

import { Estate } from '../../estates/dto/estate';
import { CompanyMember } from './company-member';

export interface EstateManager {
  id: string;
  estateId: string;
  companyMemberId: string;
  createdDate: string;
  updatedDate: string;
  deleted: boolean;
  estate?: Estate;
  companyMember?: CompanyMember;
}

export const estateManagerProps = new GraphSchema<EstateManager>([
  'id',
  'estateId',
  'companyMemberId',
  'createdDate',
  'updatedDate',
  'estate',
  'companyMember',
]);
